import { render, staticRenderFns } from "./TeacherClass.vue?vue&type=template&id=56c478ba"
import script from "./TeacherClass.vue?vue&type=script&lang=js"
export * from "./TeacherClass.vue?vue&type=script&lang=js"
import style0 from "./TeacherClass.vue?vue&type=style&index=0&id=56c478ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports